import React from "react";
import { useFormikContext } from "formik";
import TagInput from "./TagInput";

export default function Step3MarketingSeeds() {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      <h5 className="mb-1">Step 3 — Marketing seeds</h5>
      <p className="text-muted small mb-4">
        These tags pre-populate the customer's marketing setup. The operator can edit any of the
        defaults; the customer can add more later from the Setup dashboard.
      </p>

      <TagInput
        label="Document types"
        values={values.documentTypes}
        onChange={(v) => setFieldValue("documentTypes", v)}
        placeholder="Type and press Enter (e.g. Brochure)"
      />

      <TagInput
        label="Media channels"
        values={values.mediaChannels}
        onChange={(v) => setFieldValue("mediaChannels", v)}
        placeholder="Type and press Enter (e.g. Email)"
      />

      <TagInput
        label="Geographies"
        values={values.geographies}
        onChange={(v) => setFieldValue("geographies", v)}
        placeholder="Type and press Enter (e.g. US)"
      />

      <TagInput
        label="Priorities"
        values={values.priorities}
        onChange={(v) => setFieldValue("priorities", v)}
        placeholder="Type and press Enter (e.g. High)"
      />
    </>
  );
}
